/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface ApiExcelExcelExportDeductionsByClientGet$Params {
  clientID?: string;
}

export function apiExcelExcelExportDeductionsByClientGet(http: HttpClient, rootUrl: string, params?: ApiExcelExcelExportDeductionsByClientGet$Params, context?: HttpContext): Observable<StrictHttpResponse<Blob>> {
  const rb = new RequestBuilder(rootUrl, apiExcelExcelExportDeductionsByClientGet.PATH, 'get');
  if (params) {
    rb.query('clientID', params.clientID, {});
  }

  return http.request(
    rb.build({ responseType: 'blob', accept: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Blob>;
    })
  );
}

apiExcelExcelExportDeductionsByClientGet.PATH = '/api/Excel/ExcelExport_DeductionsByClient';
